<template>
  <div>
    <!-- <v-navigation-drawer>
        <v-list-item>
        <v-list-item-title class="text-h6">
            Select Manufacturer
          </v-list-item-title>
        <v-list-item-content>
          

        </v-list-item-content>
        
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-content>
          <v-select :items="manufacturers"></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <b>OR</b> Select Prefix <v-select :items="prefixes"></v-select>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer> -->
  <v-container fluid>
    <v-row>
      <v-col cols="auto">
        <v-card>
        <v-card>
          <v-card-title primary-title>
            Select Manufacturer
          </v-card-title>
          <v-card-text>
            <v-row><v-select :items="sortedMfgs" item-text="manufacturer" item-value="id" v-model="selectedMfgId"></v-select></v-row>
            <v-row><v-col cols="auto"><b>OR</b> Select Prefix</v-col><v-col><v-select v-model="selectedMfgId" :items="prefixes" item-text="prefix" item-value="id"></v-select></v-col></v-row>
            
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <v-row>Available Vendors for this Manufacturer's Items:</v-row>
            <v-row></v-row>
            <v-row></v-row>
            <v-row><span v-if="SelectedMfg">Website: {{SelectedMfg.website}}</span></v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div>
              <v-btn>Add New Mfg</v-btn>
              <v-btn :disabled="!SelectedMfg">Add Vendor</v-btn>
              <v-btn :disabled="!SelectedMfg">Edit Mfg</v-btn>
              <v-btn :disabled="!SelectedMfg">Remove Vendor</v-btn>
            </div>
          </v-card-text>
        </v-card>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
        <v-container fluid>
          <v-row>
            <v-col></v-col>
            <v-col></v-col>
          </v-row>
          <v-row><v-card></v-card></v-row>
          <v-row></v-row>
          <v-row></v-row>
          <v-row><v-card></v-card></v-row>
          
        </v-container>
        <v-card-actions>
          <v-btn>Save Changes</v-btn>
              <v-btn>Reset Changes</v-btn>
        </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
import { msalMixin } from 'vue-msal';
export default {
  name: "Vendors",
  mixins: [msalMixin],
  data() {
    return {
      manufacturers:[],
      selectedMfgId:null
      
    };
  },
  computed: {
    user() {
          let user = null;
          if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
            user = {
              ...this.msal.user,
              profile: {}
            }
            if (this.msal.graph && this.msal.graph.profile) {
                user.profile = this.msal.graph.profile
            }
          }
          return user;
        },
        sortedMfgs() {
          return this.$_.sortBy(this.manufacturers || [],'manufacturer')
        },
        prefixes() {
          return this.$_.sortBy(this.manufacturers || [],'prefix')
        },
        SelectedMfg() {
          if(this.selectedMfgId==null) return null

          return this.$_.find(this.manufacturers,m=>m.id==this.selectedMfgId)
        }
  },
  methods: {
    LoadData() {
      this.$http.get('https://api.hockenbergs.com/api/Vendor/Manufacturers')
      .then(res=>this.manufacturers=res.data)
      .catch(err=>console.error(err))
    }
  },
  mounted() {
    this.LoadData()
  }
};
</script>